import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-download-message',
    templateUrl: './download-message.component.html',
    styleUrls: ['./download-message.component.scss'],
    standalone: false
})
export class DownloadMessageComponent implements OnInit, OnDestroy{
  @Input() state: string = 'success';
  @Output() exit: EventEmitter<any> = new EventEmitter();
  message: any = {
    error: {
      title: 'Ocurrió un error al descargar tu comprobante',
      subtitle: 'Por favor, inténtalo nuevamente',
      icon: 'alert-circle-outline',
    },
    success: {
      title: 'Tu comprobante fue descargado con éxito',
      subtitle: 'Revísalo en tus descargas',
      icon: 'checkmark-circle-outline',
    }
  }
  ngOnInit() {
    document.addEventListener('keydown', this.handleKeydown.bind(this));
  }

  ngOnDestroy() {
    document.removeEventListener('keydown', this.handleKeydown.bind(this));
  }

  handleKeydown(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.closeMessage();
    }
  }
  
  closeMessage() {
    this.exit.emit();
  }

}
